import styled from "styled-components";
import { spacing, FrameContent } from "@conserveit/blocks";

export const ReportWrapper = styled.div`
  width: 100%;
`;

export const Content = styled(FrameContent)`
  padding: ${spacing.extraLoose};
  min-height: 500px;
  width: 100%;
`;
